'use client';
import { useState, useEffect, ChangeEvent } from 'react';
import './MyProfile.scss';
import 'react-phone-input-2/lib/style.css';

import BackIcon from '@/assets/img/back-icon.svg';
import { useParams } from 'react-router-dom';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { isMobile } from 'react-device-detect';
import { AppointmentData } from '../types';
import { Loader } from '@/components/Loader/Loader';
import { useAuth } from '@/lib/auth';
import ProfileIcon from '@/assets/img/v2/Profile-1-v2.png';
import CallingIcon from '@/assets/img/v2/Calling-1-v2.svg';
import CallingIvr from '@/assets/img/Calling-2-v2.svg';
import AddressIcon from '@/assets/img/address-v2.png';
import Smsicon from '@/assets/img/Message-v2.svg';
import { FileUploader } from '../../availability/components/FileUploader';
import { ParentProfile } from '../components/ParentProfile';
import { showNotification } from '@/utils/notificationUtils';
import { useUpdateParentProfile, useUploadPicture } from '../api/updateParentProfile';
import Utils from '@/utils/util';
import { UseScreenOrientation } from '@/utils/Orientation';
import { useTranslation } from 'react-i18next';
export type ParentData = {
  fName: string;
  lName: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  apt?: string;
  country: string;
  imageUrl?: string;
  optOutIvr?: string;
  optOutSms?: string;
  name?: string;
  id?: string;
  lat?: number;
  lng?: number;
  altEmails?:string[]
};

export default function MyProfile() {
  const isLandscape = UseScreenOrientation();
  const { slug } = useParams();
  const { user, refetchUser } = useAuth();
  const [isEdit, setIsEdit] = useState(false);
  const showBackNav = false;
  const [petParentData, setPetParentData] = useState<ParentData>({
    fName: '',
    lName: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    apt: '',
    country: 'US',
    imageUrl: '',
    optOutIvr: '',
    optOutSms: '',
    name: '',
    id: '',
    altEmails: [],
  });
  const updateParentProfileMutation = useUpdateParentProfile();
  const updateProfilePicMutation = useUploadPicture();
  useEffect(() => {
    if (user) {
      petParentData.fName = user?.firstName;
      petParentData.name = user?.name;
      petParentData.lName = user?.lastName;
      petParentData.phone = user?.phone;
      petParentData.address = user?.address;
      petParentData.city = user?.city;
      petParentData.state = user?.state;
      petParentData.zip = user?.zip;
      petParentData.apt = user?.apt;
      petParentData.imageUrl = user?.imageUrl;
      petParentData.altEmails = user?.altEmails;
      petParentData.country = 'US';
      petParentData.optOutIvr = user?.optOutIvr ? 'true' : 'false';
      petParentData.optOutSms = user?.optOutSms ? 'true' : 'false';
      petParentData.id = user?.id;
      petParentData.lat = user?.lat;
      petParentData.lng = user?.lng;
      if (user?.name) {
        const names = user?.name.split(' ');
        petParentData.fName = names && names.length > 0 ? names[0] : user?.firstName;
        petParentData.lName = names && names.length > 0 ? names[1] : user?.lastName;
      }

      setPetParentData({ ...petParentData });
    }
  }, [user]);
  const { t, i18n } = useTranslation();

  const onProfilePicUpload = async (formData: FormData) => {
    const response = await updateProfilePicMutation.mutateAsync({
      file: formData,
    });
    onFormValueChange('imageUrl', response ? response.imageUrl : '');
  };
  const onFormValueChange = (formFieldName: string, value: any) => {
    (petParentData as any)[formFieldName] = value;
    setPetParentData({ ...petParentData });
    submitParentData();
  };
  const submitParentData = async () => {
    if (!updateParentProfileMutation.isLoading) {
      const { fName, id, lName, phone, address, city, state, zip, apt, country, imageUrl, altEmails, name, lat, lng } =
        petParentData;
      await updateParentProfileMutation.mutateAsync({
        data: {
          id: id,
          name: name,
          firstName: fName,
          phone: phone,
          lastName: lName,
          address,
          city,
          state,
          zip,
          apt,
          country,
          altEmails: altEmails ? altEmails : [],
          optOutIvr: petParentData.optOutIvr == 'true' ? true : false,
          optOutSms: petParentData.optOutSms == 'true' ? true : false,
          imageUrl: imageUrl ? imageUrl : '',
          lat,
          lng,
        },
      });
      setIsEdit(false);
      refetchUser();
    }
  };

  const getDivVisibleStatus = () => {
    if (!isLandscape && isEdit) {
      return true;
    }
    if (!isLandscape && !isEdit) {
      return false;
    }
    if (isLandscape) {
      return true;
    }
  };
  const getDivVisibleStatusForLeftDiv = () => {
    if (!isLandscape && isEdit) {
      return false;
    }
    if (!isLandscape && !isEdit) {
      return true;
    }
    if (isLandscape) {
      return true;
    }
  };

  return (
    <section className="petsked-container-bg my-profile">
      {!showBackNav ? (
        <>
          {!isEdit ? (
            <div
              className={`heading-section left my-payment-add-new-btn profile-padding-20 ${
                !isLandscape ? 'remove-bg-white' : ''
              }`}
            >
              <div>
                <h5>
                  {t('Your')} <span>{t('profile')}</span>
                </h5>
                {/* <p>
                Lorem ipsum dolor sit amet, consectetur lorem adipiscing elit, sed do ipsum eiusmod.
              </p> */}
              </div>
            </div>
          ) : (
            <div
              className="back-nav-btn"
              onClick={() => {
                setIsEdit(false);
              }}
            >
              <img src={BackIcon} alt="back icon" />
              <span>{t('Back')}</span>
            </div>
          )}

          <div>
            <div className="profile-details">
              <div className="profile-left-div">
                <div className={`business-info `}>
                  <FileUploader
                    key={'parent-profile-pic'}
                    onUpload={onProfilePicUpload}
                    url={petParentData.imageUrl}
                    isUploading={updateProfilePicMutation.isLoading}
                  />
                </div>
                {getDivVisibleStatusForLeftDiv() && (
                  <>
                    <div className="parent-info-div">
                      <div className="parent-info-icon">
                        <img src={ProfileIcon} />
                      </div>
                      <div className="parent-info-detailss">
                        <div>{petParentData?.name}</div>
                        <div className="title-div">{t('Full name')}</div>
                      </div>
                    </div>
                    <div className="parent-info-div">
                      <div className="parent-info-icon">
                        <img src={CallingIcon} />
                      </div>
                      <div className="parent-info-detailss">
                        <div>{Utils.formatPhoneNumber(petParentData?.phone)}</div>
                        <div className="title-div">{t('Contact')}</div>
                      </div>
                    </div>
                    <div className="parent-info-div">
                      <div className="parent-info-icon">
                        <img src={AddressIcon} />
                      </div>
                      <div className="parent-info-detailss">
                        <div>{Utils.getAddress(petParentData)}</div>
                        <div className="title-div">{t('Address')}</div>
                      </div>
                    </div>
                    <div className="parent-info-div">
                      <div className="parent-info-icon">
                        <img src={Smsicon} />
                      </div>
                      <div className="parent-info-detailss">
                        <div>{petParentData?.optOutSms === 'true' ? 'Enabled' : 'Disabled'}</div>
                        <div className="title-div">{t('SMS notification')}</div>
                      </div>
                    </div>
                    <div className="parent-info-div">
                      <div className="parent-info-icon">
                        <img src={CallingIvr} />
                      </div>
                      <div className="parent-info-detailss">
                        <div>{petParentData?.optOutIvr === 'true' ? 'Enabled' : 'Disabled'}</div>
                        <div className="title-div">{t('Calling notification')}</div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="profile-right-div">
                {getDivVisibleStatus() && (
                  <>
                    <ParentProfile
                      onNext={(page) => {
                        setIsEdit(false);
                      }}
                      onBackClick={() => {}}
                    />
                  </>
                )}

                {!isLandscape && !isEdit && (
                  <div className="action mb-4 ">
                    <button
                      className="petsked-button button-dark"
                      onClick={() => {
                        if (!isEdit) {
                          setIsEdit(true);
                        }
                      }}
                      disabled={updateParentProfileMutation.isLoading}
                    >
                      {updateParentProfileMutation.isLoading ? (
                        <Loader />
                      ) : (
                        <>{isEdit ? <span>{t('Update Profile')}</span> : <span>{t('Edit Profile')}</span>}</>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <BackNav onClick={() => {}} />
      )}
    </section>
  );
}
